export default "__VITE_ASSET__BJLhHje0__"